import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedAppComponent } from '../../../shared/src/lib/shared-app.component';
import { ToastNotificationsComponent } from '@serene-dev/toast-notifications';
import { UserHelperComponent } from '../../../shared/src/lib/components/components';
import { VersionNoComponent } from "projects/shared/src/lib/components/version-no/version-no.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastNotificationsComponent, UserHelperComponent, VersionNoComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends SharedAppComponent {
  constructor() {
    super();
    this.uS.config.appName = `Insurance Regulatory Platform`;
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
